// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8058ed82","453":"d3de9e5d"}[chunkId] + ".chunk.js";
};